import React, { useState, useRef } from "react";
import "../styles/Home.css";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

const Home = () => {
  const [activeImage, setActiveImage] = useState(null);
  const sliderRef = useRef(null);
  const navigate = useNavigate();
  const { language } = useLanguage();

  const items = [
    {
      title: "Development",
      tamiltitle: "வளர்ச்சி",
      description: "Focused on infrastructure growth, technology advancement, and economic progress for the nation.",
      tamildescription: "முதன்மை கட்டமைப்பு வளர்ச்சி, தொழில்நுட்ப முன்னேற்றம் மற்றும் நாட்டின் பொருளாதார முன்னேற்றத்தில் கவனம் செலுத்துகிறோம்.",
      image: "/assets/sudha-bjp/up1.png"
    },
    {
      title: "Good Governance",
      tamiltitle: "நல்லாட்சி",
      description: "Transparent, accountable, and citizen-centric governance for efficient public services.",
      tamildescription: "வெளிப்படை, பொறுப்பு மற்றும் குடிமக்கள் மைய ஆட்சி திறமையான பொது சேவைகளை வழங்குகிறது.",
      image: "/assets/sudha-bjp/shield1.png"
    },
    {
      title: "National Security",
      tamiltitle: "தேசிய பாதுகாப்பு",
      description: "Strengthening defense, internal security, and safeguarding national interests.",
      tamildescription: "பாதுகாப்பு, உள் பாதுகாப்பு மற்றும் தேசிய நலன்களை பலப்படுத்துதல்.",
      image: "/assets/sudha-bjp/shield1.png"
    },
    {
      title: "Inclusive Growth",
      tamiltitle: "அனைவரையும் உள்ளடக்கிய வளர்ச்சி",
      description: "Ensuring equal opportunities, social justice, and sustainable growth for all communities.",
      tamildescription: "அனைத்து சமூகங்களுக்கும் சம வாய்ப்புகள், சமூக நீதி மற்றும் நிலையான வளர்ச்சி உறுதி செய்கிறோம்.",
      image: "/assets/sudha-bjp/group1.png"
    }
  ];

  const leaders = [
    {
      title: "Narendra Modi",
      tamiltitle: "நரேந்திர மோடி",
      description: "PRIME MINISTER",
      tamildescription: "பிரதமர்",
      image: "/assets/modi.jpg"
    },
    {
      title: "Nainar Nagenthran",
      tamiltitle: "நைனார் நகந்திரன்",
      description: "Tamil Nadu BJP President",
      tamildescription: "தமிழ்நாடு பாஜக தலைவர்",
      image: "/assets/nainar.jpg"
    },
    {
      title: "R. Sudha RadhaKrishnan",
      tamiltitle: "ஆர். சுதா ராதாகிருஷ்ணன்",
      description: "District Vice President (Mahila Morcha)",
      tamildescription: "மாவட்ட மகளிர் அணி துணை தலைவி (மகளிர் மோர்ச்சா)",
      image: "/assets/sudha-bjp/Legacymain.jpeg"
    }
  ];

  const galleryImages = [
    "/assets/images/1.jpeg",
    "/assets/images/2.jpeg",
    "/assets/images/3.jpeg",
    "/assets/images/4.jpeg",
    "/assets/images/5.jpeg",
    "/assets/images/6.jpeg",
    "/assets/images/7.jpeg",
    "/assets/images/8.jpeg",
    "/assets/images/9.jpeg",
    "/assets/images/10.jpeg",
    "/assets/images/11.jpeg"
  ];

  const content = {
    heroTitle: {
      english: "R. Sudha RadhaKrishnan",
      tamil: "ஆர். சுதா ராதாகிருஷ்ணன்"
    },
    heroSubtitle: {
      english: "District Vice President (Mahila Morcha), Veerapandi, Salem East.",
      tamil: "மாவட்ட மகளிர் அணி துணை தலைவி, (மகளிர் மோர்ச்சா) வீரபாண்டி, சேலம் கிழக்கு."
    },
    heroTagline: {
      english: "With everyone, for everyone's development, with everyone's trust.",
      tamil: "அனைவருடனும், அனைவரின் வளர்ச்சிக்காகவும், அனைவரின் நம்பிக்கையுடனும்."
    },
    coreFocus: {
      english: "Our Core Focus",
      tamil: "எங்கள் முக்கிய கவனம்"
    },
    leadership: {
      english: "Leadership Legacy",
      tamil: "தலைமைத்துவ மரபு"
    },
    transformingIndia: {
      english: "Transforming India",
      tamil: "இந்தியாவை மாற்றியமைத்தல்"
    },
    transformingDescription: {
      english: "Through visionary policies and relentless execution, building the foundation for a developed nation.",
      tamil: "தொலைநோக்கு கொள்கைகள் மற்றும் தளராத செயல்பாட்டின் மூலம், ஒரு வளர்ந்த நாட்டின் அடித்தளத்தை கட்டி எழுப்புகிறோம்."
    },
    viewAchievements: {
      english: "View All Achievements",
      tamil: "அனைத்து சாதனைகளையும் காண்க"
    },
    galleryTitle: {
      english: "Moments & Activities",
      tamil: "நிகழ்வுகள் & செயல்பாடுகள்"
    },
    joinMovement: {
      english: "Join the Movement",
      tamil: "இயக்கத்தில் சேருங்கள்"
    },
    joinDescription: {
      english: "Be a part of nation building. Connect with us today.",
      tamil: "தேசம் கட்டும் பணியில் பங்கேற்கவும். இன்றே எங்களுடன் தொடர்பு கொள்ளுங்கள்."
    },
    infrastructure: {
      english: "Infrastructure",
      tamil: "உள்கட்டமைப்பு"
    },
    digitalIndia: {
      english: "Digital India",
      tamil: "டிஜிட்டல் இந்தியா"
    },
    education: {
      english: "Education",
      tamil: "கல்வி"
    },
    healthcare: {
      english: "Healthcare",
      tamil: "சுகாதாரம்"
    }
  };

  return (
    <>
      <section className="hero">
        <div className="hero-container">
          <div className="hero-left">
            <h1>{content.heroTitle[language]}</h1>
            <p>
              {content.heroSubtitle[language]}
            </p>
            <p className="lighttext">{content.heroTagline[language]}</p>
            <div className="hero-buttons">
              <button
                className="outline"
                onClick={() => navigate("/Mission-vission")}
              >
                {language === 'tamil' ? 'குறிக்கோள் & பார்வை' : 'Mission & Vision'}
              </button>

              <button
                className="outline"
                onClick={() => navigate("/About")}
              >
                {language === 'tamil' ? 'எங்களை பற்றி' : 'About Us'}
              </button>

              <button
                className="outline"
                onClick={() => navigate("/Contact")}
              >
                {language === 'tamil' ? 'தொடர்பு கொள்ளுங்கள்' : 'Contact Us'}
              </button>
            </div>
          </div>

          <div className="hero-right">
            <div className="image-card">
              <div className="image-placeholder"><img src="/assets/sudha-bjp/homemain.jpeg" alt="" /></div>
            </div>
          </div>
        </div>
      </section>
      <section className="core-focus">
        <h2 className="coretitle">{content.coreFocus[language]}</h2>
        <div className="focus-grid">
          {items.map((item, i) => (
            <div key={i} className="focus-card">
              <img src={item.image} alt="" />
              <h4>{language === 'tamil' ? item.tamiltitle : item.title}</h4>
              <p>{language === 'tamil' ? item.tamildescription : item.description}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="leadership">
        <h2 className="coretitle coretitle1">{content.leadership[language]}</h2>
        <div className="leader-grid">
          {leaders.map((leader, i) => (
            <div key={i} className={`leader-card`}>
              <img src={leader.image} alt="" className="leader-img" />
              <h4 className="leadtitle">{language === 'tamil' ? leader.tamiltitle : leader.title}</h4>
              <p className="leaddesc">{language === 'tamil' ? leader.tamildescription : leader.description}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="transform">
        <div className="transform-left">
          <h2 className="transform-left1">{content.transformingIndia[language]}</h2>
          <p className="transform-left3">
            {content.transformingDescription[language]}
          </p>
          <button onClick={() => navigate("/Mission-vission")} className="outline">{content.viewAchievements[language]}</button>
        </div>

        <div className="transform-right">
          <div className="icon-card">
            <span className="transimg"><img src="/assets/sudha-bjp/up.png" alt="" /></span>
            {content.infrastructure[language]}
          </div>
          <div className="icon-card">
            <span className="transimg"><img src="/assets/sudha-bjp/bulb.png" alt="" /></span>
            {content.digitalIndia[language]}
          </div>
          <div className="icon-card">
            <span className="transimg"><img src="/assets/sudha-bjp/group.png" alt="" /></span>
            {content.education[language]}
          </div>
          <div className="icon-card">
            <span className="transimg"><img src="/assets/sudha-bjp/shield2.png" alt="" /></span>
            {content.healthcare[language]}
          </div>
        </div>
      </section>
      <section className="gallery">
        <div className="galbtn">
          <h2 className="coretitle coretitle2">{content.galleryTitle[language]}</h2>
          <button className="explore-btn" onClick={() => navigate("/Events-gallery")}>Explore more <img src="/assets/rarrow.png" alt="" /></button>
        </div>

        <div className="masonry">
          {galleryImages.map((img, i) => (
            <div
              key={i}
              className="masonry-item animate"
              onClick={() => setActiveImage(i)}
            >
              <img src={img} alt="" />
            </div>
          ))}
        </div>
      </section>

      <section className="join">
        <h2>{content.joinMovement[language]}</h2>
        <p>{content.joinDescription[language]}</p>

        <div className="contact-boxes">
          <div className="contact-boxespar">
            <img src="/assets/sudha-bjp/phone2.png" alt="" /> 9176995369
          </div>
          <div className="contact-boxespar">
            <img src="/assets/sudha-bjp/comment.png" alt="" /> 9894081162
          </div>
          <div className="contact-boxespar">
            <img src="/assets/sudha-bjp/mail2.png" alt="" /> bjpsudharadhakrishnan <br /> 2025@gmail.com
          </div>
        </div>
      </section>
      {activeImage !== null && (
        <div className="fullscreen" onClick={() => setActiveImage(null)}>
          <span className="close">×</span>

          <div
            className="fullscreen-slider"
            ref={sliderRef}
            onTouchStart={(e) =>
              (sliderRef.current.startX = e.touches[0].clientX)
            }
            onTouchEnd={(e) => {
              const diff =
                sliderRef.current.startX - e.changedTouches[0].clientX;
              if (diff > 50 && activeImage < galleryImages.length - 1)
                setActiveImage(activeImage + 1);
              if (diff < -50 && activeImage > 0)
                setActiveImage(activeImage - 1);
            }}
          >
            <img src={galleryImages[activeImage]} alt="" />
          </div>
        </div>
      )}
    </>
  );
};

export default Home;